import Rollbar from 'rollbar'

function readMetaContent(name) {
  const meta = document.querySelector(`meta[name="${name}"]`)
  return meta ? (meta.getAttribute('content') || '').trim() : ''
}

export function shouldIgnoreRollbarPayload(payload) {
  const description = payload?.body?.trace?.exception?.description || ''
  const message = payload?.body?.message?.body || ''
  const combined = `${description} ${message}`.toLowerCase()

  if (combined.includes('resizeobserver loop completed with undelivered notifications')) return true
  if (combined.includes('resizeobserver loop limit exceeded')) return true

  // Firefox reports expected media fetch cancellations as AbortError when a source
  // is replaced or playback is interrupted by the browser/user.
  if (combined.includes('aborterror')) {
    if (combined.includes('media resource')) return true
    if (combined.includes('fetching process for the media resource was aborted')) return true
  }

  return false
}

export function initRollbarClient() {
  if (typeof window === 'undefined') return null

  const accessToken = readMetaContent('rollbar-client-access-token')
  if (!accessToken) return null

  const environment = readMetaContent('rollbar-environment') || 'production'
  const codeVersion = readMetaContent('rollbar-code-version') || 'unknown'

  window.Audiocrowd = window.Audiocrowd || {}
  if (window.Audiocrowd.Rollbar) return window.Audiocrowd.Rollbar

  const rollbar = new Rollbar({
    accessToken,
    captureUncaught: true,
    captureUnhandledRejections: true,
    autoInstrument: true,
    checkIgnore: (_isUncaught, _args, payload) => shouldIgnoreRollbarPayload(payload),
    payload: {
      environment,
      context: window.location.pathname,
      client: {
        javascript: {
          source_map_enabled: true,
          code_version: codeVersion
        }
      },
      custom: {
        controller_path: document.body ? document.body.dataset.controllerPath : '',
        action_name: document.body ? document.body.dataset.actionName : ''
      }
    }
  })

  window.Audiocrowd.Rollbar = rollbar
  return rollbar
}
